export const defaultNumberPlayersDayTrials = [
    { name: '20 Players', value: 20 },
    { name: '50 Players', value: 50 }
  ];
export const defaultNumberPlayers = [
    { name: '1 Players', value: 1 },
    { name: '2 Players', value: 2 },
    { name: '3 Players', value: 3 },
    { name: '4 Players', value: 4 },
    { name: '5 Players', value: 5 },
    { name: '6 Players', value: 6 },
    { name: '7 Players', value: 7 },
    { name: '8 Players', value: 8 },
    { name: '9 Players', value: 9 },
    { name: '10 Players', value: 10 },
    { name: '11 Players', value: 11 },
    { name: '12 Players', value: 12 },
    { name: '13 Players', value: 13 },
    { name: '14 Players', value: 14 },
    { name: '15 Players', value: 15 },
    { name: '16 Players', value: 16 },
    { name: '17 Players', value: 17 },
    { name: '18 Players', value: 18 },
    { name: '19 Players', value: 19 },
    { name: '20 Players', value: 20 },
    { name: '21 Players', value: 21 },
    { name: '22 Players', value: 22 },
    { name: '23 Players', value: 23 },
    { name: '24 Players', value: 24 },
    { name: '25 Players', value: 25 },
    { name: '26 Players', value: 26 },
    { name: '27 Players', value: 27 },
    { name: '28 Players', value: 28 },
    { name: '29 Players', value: 29 },
    { name: '30 Players', value: 30 },
    { name: '31 Players', value: 31 },
    { name: '32 Players', value: 32 },
    { name: '33 Players', value: 33 },
    { name: '34 Players', value: 34 },
    { name: '35 Players', value: 35 },
    { name: '36 Players', value: 36 },
    { name: '37 Players', value: 37 },
    { name: '38 Players', value: 38 },
    { name: '39 Players', value: 39 },
    { name: '40 Players', value: 40 },
    { name: '41 Players', value: 41 },
    { name: '42 Players', value: 42 },
    { name: '43 Players', value: 43 },
    { name: '44 Players', value: 44 },
    { name: '45 Players', value: 45 },
    { name: '46 Players', value: 46 },
    { name: '47 Players', value: 47 },
    { name: '48 Players', value: 48 },
    { name: '49 Players', value: 49 },
    { name: '50 Players', value: 50 },
    { name: '51 Players', value: 51 },
    { name: '52 Players', value: 52 },
    { name: '53 Players', value: 53 },
    { name: '54 Players', value: 54 },
    { name: '55 Players', value: 55 },
    { name: '56 Players', value: 56 },
    { name: '57 Players', value: 57 },
    { name: '58 Players', value: 58 },
    { name: '59 Players', value: 59 },
    { name: '60 Players', value: 60 },
    { name: '61 Players', value: 61 },
    { name: '62 Players', value: 62 },
    { name: '63 Players', value: 63 },
    { name: '64 Players', value: 64 },
    { name: '65 Players', value: 65 },
    { name: '66 Players', value: 66 },
    { name: '67 Players', value: 67 },
    { name: '68 Players', value: 68 },
    { name: '69 Players', value: 69 },
    { name: '70 Players', value: 70 },
    { name: '71 Players', value: 71 },
    { name: '72 Players', value: 72 },
    { name: '73 Players', value: 73 },
    { name: '74 Players', value: 74 },
    { name: '75 Players', value: 75 },
    { name: '76 Players', value: 76 },
    { name: '77 Players', value: 77 },
    { name: '78 Players', value: 78 },
    { name: '79 Players', value: 79 },
    { name: '80 Players', value: 80 },
    { name: '81 Players', value: 81 },
    { name: '82 Players', value: 82 },
    { name: '83 Players', value: 83 },
    { name: '84 Players', value: 84 },
    { name: '85 Players', value: 85 },
    { name: '86 Players', value: 86 },
    { name: '87 Players', value: 87 },
    { name: '88 Players', value: 88 },
    { name: '89 Players', value: 89 },
    { name: '90 Players', value: 90 },
    { name: '91 Players', value: 91 },
    { name: '92 Players', value: 92 },
    { name: '93 Players', value: 93 },
    { name: '94 Players', value: 94 },
    { name: '95 Players', value: 95 },
    { name: '96 Players', value: 96 },
    { name: '97 Players', value: 97 },
    { name: '98 Players', value: 98 },
    { name: '99 Players', value: 99 },
    { name: '100 Players', value: 100 },
    { name: '101 Players', value: 101 },
    { name: '102 Players', value: 102 },
    { name: '103 Players', value: 103 },
    { name: '104 Players', value: 104 },
    { name: '105 Players', value: 105 },
    { name: '106 Players', value: 106 },
    { name: '107 Players', value: 107 },
    { name: '108 Players', value: 108 },
    { name: '110 Players', value: 100 },
    { name: '111 Players', value: 111 },
    { name: '112 Players', value: 112 },
    { name: '113 Players', value: 113 },
    { name: '114 Players', value: 114 },
    { name: '115 Players', value: 115 },
    { name: '116 Players', value: 116 },
    { name: '117 Players', value: 117 },
    { name: '118 Players', value: 118 },
    { name: '119 Players', value: 119 },
    { name: '120 Players', value: 120 },
    { name: '121 Players', value: 121 },
    { name: '122 Players', value: 122 },
    { name: '123 Players', value: 123 },
    { name: '124 Players', value: 124 },
    { name: '125 Players', value: 125 },
    { name: '126 Players', value: 126 },
    { name: '127 Players', value: 127 },
    { name: '128 Players', value: 128 },
    { name: '129 Players', value: 129 },
    { name: '130 Players', value: 130 },
    { name: '131 Players', value: 131 },
    { name: '132 Players', value: 132 },
    { name: '133 Players', value: 133 },
    { name: '134 Players', value: 134 },
    { name: '135 Players', value: 135 },
    { name: '136 Players', value: 136 },
    { name: '137 Players', value: 137 },
    { name: '138 Players', value: 138 },
    { name: '139 Players', value: 139 },
    { name: '140 Players', value: 140 },
    { name: '141 Players', value: 141 },
    { name: '142 Players', value: 142 },
    { name: '143 Players', value: 143 },
    { name: '144 Players', value: 144 },
    { name: '145 Players', value: 145 },
    { name: '146 Players', value: 146 },
    { name: '147 Players', value: 147 },
    { name: '148 Players', value: 148 },
    { name: '149 Players', value: 149 },
    { name: '150 Players', value: 150 },
    { name: '151 Players', value: 151 },
    { name: '152 Players', value: 152 },
    { name: '153 Players', value: 153 },
    { name: '154 Players', value: 154 },
    { name: '155 Players', value: 155 },
    { name: '156 Players', value: 156 },
    { name: '157 Players', value: 157 },
    { name: '158 Players', value: 158 },
    { name: '159 Players', value: 159 },
    { name: '160 Players', value: 160 },
    { name: '161 Players', value: 161 },
    { name: '162 Players', value: 162 },
    { name: '163 Players', value: 163 },
    { name: '164 Players', value: 164 },
    { name: '165 Players', value: 165 },
    { name: '166 Players', value: 166 },
    { name: '167 Players', value: 167 },
    { name: '168 Players', value: 168 },
    { name: '169 Players', value: 169 },
    { name: '170 Players', value: 170 },
    { name: '171 Players', value: 171 },
    { name: '172 Players', value: 172 },
    { name: '173 Players', value: 173 },
    { name: '174 Players', value: 174 },
    { name: '175 Players', value: 175 },
    { name: '176 Players', value: 176 },
    { name: '177 Players', value: 177 },
    { name: '178 Players', value: 178 },
    { name: '179 Players', value: 179 },
    { name: '180 Players', value: 180 },
    { name: '181 Players', value: 181 },
    { name: '182 Players', value: 182 },
    { name: '183 Players', value: 183 },
    { name: '184 Players', value: 184 },
    { name: '185 Players', value: 185 },
    { name: '186 Players', value: 186 },
    { name: '187 Players', value: 187 },
    { name: '188 Players', value: 188 },
    { name: '189 Players', value: 189 },
    { name: '190 Players', value: 190 },
    { name: '191 Players', value: 191 },
    { name: '192 Players', value: 192 },
    { name: '193 Players', value: 193 },
    { name: '194 Players', value: 194 },
    { name: '195 Players', value: 195 },
    { name: '196 Players', value: 196 },
    { name: '197 Players', value: 197 },
    { name: '198 Players', value: 198 },
    { name: '199 Players', value: 199 },
    { name: '200 Players', value: 200 },
  ];